export default "__VITE_ASSET__iWa5eBWB__"